var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getButtonClass,on:{"click":function($event){return _vm.handleClick()}}},[_vm._v("\n  "+_vm._s(_vm.getButtonText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }